import { componentText } from './i18n_utils';

export const splitEventsByFavorites = (eventsList = {}, favoritesByEvent = {}) => {
  const favoriteIds = new Set(Object.keys(favoritesByEvent));
  const favoriteEvents = {};
  const otherEvents = {};

  for (const [specId, events] of Object.entries(eventsList)) {
    const fav = [];
    const other = [];

    for (const ev of events || []) {
      const eventId = String(ev?.id ?? '');
      if (!eventId) continue;
      (favoriteIds.has(eventId) ? fav : other).push(ev);
    }

    if (fav.length) favoriteEvents[specId] = fav;
    if (other.length) otherEvents[specId] = other;
  }

  return { favoriteEvents, otherEvents };
};

// Same message the manager site's legacy page shows for a round without
// tournaments. Kept in the leaderboard's own catalog: the legacy key belongs
// to the manager Transifex project, which lacks the portal-only languages.
export const noTournamentsMessage = () =>
  componentText('events_list.no_tournaments_for_round', 'There are no tournaments defined for this round.');

// A summaries-only customized page deliberately selects no events (its round
// entries carry a present-but-empty event_ids) - the no-tournaments message
// must not show for such a round.
export const isSummariesOnlyRound = (roundList = [], roundId) => {
  const currentRound = roundList.find((round) => String(round.id) === String(roundId));
  return Array.isArray(currentRound?.event_ids) && currentRound.event_ids.length === 0;
};

export const pickTranslatedName = (nameTranslations, fallbackName) => {
  const locale = !window.I18n ? null : window.I18n.locale;
  return (locale && nameTranslations?.[locale]) || fallbackName;
};

export const findEventById = (eventsList, selectedEventId) => {
  for (const events of Object.values(eventsList)) {
    for (const event of events || []) {
      if (event.snapshots?.length) {
        const match = event.snapshots.find((s) => s.id === selectedEventId);
        if (match) return event;
      } else if (event.id === selectedEventId) {
        return event;
      }
    }
  }
  return null;
};
